export default __webpack_public_path__ + "1ae34c68bad83c8b9efdf965873ae7c9.woff";